import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  darker?: boolean;
  id?: string;
}
export function Section({
  children,
  className = '',
  darker = false,
  id
}: SectionProps) {
  return <section id={id} className={`py-10 md:py-24 px-4 sm:px-6 lg:px-8 ${darker ? 'bg-navy-900' : 'bg-navy-800'} ${className}`} data-id="element-322">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto" data-id="element-323">
        {children}
      </motion.div>
    </section>;
}